import React, { useEffect, useState } from 'react';
import { Row, Col, Modal, Button, message, Select } from 'antd';
import { ShoppingOutlined } from '@ant-design/icons';
import { Button as MuiButton } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import YFinput from '../elements/YFInput';
import YFTextArea from '../elements/YFTextArea';
import { countries, getStateOfCountry } from '../../utils/countries';
import { useLocation, useHistory } from 'react-router-dom';
import { createSubscription } from '../../api';
import useApplicationSession from '../../session/UserSession';
import { SUBSCRIPTION_CONTRACT, SUBSCRIPTION_SUCCESSFUL } from '../../route/AppRouter';
import queryString from 'query-string';
import road from '../../assets/images/road.svg';
import car from '../../assets/images/car.svg';
import { Affix } from 'antd';

const { Option } = Select;

const DeliveryInformationForm = ({ value }) => {
    const { profile, payments } = value;
    const { register, handleSubmit, control, errors, setValue } = useForm();
    const [stateOfCountry, setSateOfCountry] = useState([]);
    const history = useHistory();
    const location = useLocation();
    const token = useApplicationSession();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (profile !== null) {
            const values = [];
            const keys = Object.keys(profile);
            keys.forEach((key) => {
                values.push({ [key]: profile[key] });
            });
            setValue(values);
        }
    }, [setValue, profile]);

    const onSubmit = (data) => {
        setLoading(true);
        /**
         * 1 is default card
         */
        const payment = payments.filter((item) => {
            return item.is_primary === 1;
        });
        const subscriptionInfo = queryString.parse(location.search);
        const request = {
            vehicle_id: subscriptionInfo.vehicle_id,
            allowed_km_per_month: subscriptionInfo.allowed_km_per_month,
            number_of_month: subscriptionInfo.number_of_month,
            monthly_rate: parseInt(subscriptionInfo.monthly_rate),
            payment_card_id: payment[0].id,
            delivery: {
                address_line_one: data.address,
                post_code: data.post_code,
                longitude: '0',
                latitude: '0',
            },
        };

        const hide = message.loading('Submitting subscription...');
        createSubscription({ token, request })
            .then((response) => {
                hide();
                message.success(response.message);
                history.push(SUBSCRIPTION_SUCCESSFUL, { data: response.data });
            })
            .catch((error) => {
                hide();
                if (error?.response?.status === 409) {
                    Modal.info({
                        title: 'Information',
                        content: error?.response?.data?.message,
                    });
                } else {
                    message.error('Subscription Failed.');
                }
                setLoading(false);
            });
    };

    const onBack = () => {
        history.push({
            pathname: `${SUBSCRIPTION_CONTRACT}`,
            search: location.search,
        });
    };

    return (
        <div className="formStatus">
            <form
                test_id="subscription-delivery-form"
                className="payment-information-form"
                onSubmit={handleSubmit(onSubmit)}
            >
                <div className="payment-information-label-container">
                    <ShoppingOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                    <h4 className="payment-information-label">Delivery Information</h4>
                </div>
                <Row>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container"
                    >
                        <YFTextArea
                            test_id="subscription-delivery-address"
                            name="address"
                            type="text"
                            label="Address"
                            placeholder="Enter Address"
                            rows={8}
                            register={register({ required: true })}
                        />
                        <div className="form-error">
                            {errors.address && <span className="formFieldError">Please enter your address. </span>}
                        </div>
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <label>Country</label>
                        <Controller
                            name="country"
                            as={
                                <Select
                                    showSearch
                                    id="subscription-delivery-country"
                                    className="yf-select"
                                    style={{ width: '100%' }}
                                    placeholder="Select Country"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {countries.map((item) => {
                                        return (
                                            <Option value={item.value} key={item.id}>
                                                {item.label}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            }
                            onChange={([selected]) => {
                                setSateOfCountry(getStateOfCountry(selected));
                                return selected;
                            }}
                            control={control}
                            rules={{ required: true }}
                        />
                        <div className="form-error">
                            {errors.country && <span className="formFieldError"> Please select your country. </span>}
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <label htmlFor="state">State</label>
                        <Controller
                            name="state"
                            as={
                                <Select
                                    showSearch
                                    id="subscription-delivery-state"
                                    className="yf-select"
                                    style={{ width: '100%' }}
                                    placeholder="Select Country"
                                    // ref={inputRef}ß
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {stateOfCountry.map((item) => {
                                        return (
                                            <Option value={item.value} key={item.id}>
                                                {item.label}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            }
                            onChange={([selected]) => {
                                return selected;
                            }}
                            rules={{ required: true }}
                            control={control}
                        />
                        <div className="form-error">
                            {errors.state && <span className="formFieldError"> Please enter your state. </span>}
                        </div>
                    </Col>
                </Row>

                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            id="subscription-delivery-city"
                            name="city"
                            type="text"
                            label="City"
                            // defaultValue={value?.city}
                            placeholder="Enter City"
                            register={register({ required: true })}
                        />
                        <div className="form-error">
                            {errors.city && <span className="formFieldError"> Please enter your city. </span>}
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            id="subscription-delivery-post-code"
                            name="post_code"
                            type="number"
                            min="0"
                            step="0"
                            label="Postal Code"
                            placeholder="Enter Postal Code"
                            register={register({ required: true })}
                        />
                        <div className="form-error">
                            {errors.post_code && (
                                <span className="formFieldError"> Please enter your postal code. </span>
                            )}
                        </div>
                    </Col>
                </Row>
                <div className="subscriptionContentContainerSteps">
                    <MuiButton onClick={() => onBack()} className="secondary-btn profilePrev">
                        back
                    </MuiButton>
                    <Button
                        test_id="subscription-delivery-submit"
                        loading={loading}
                        className="secondary-btn profileNext"
                        htmlType="submit"
                    >
                        SUBSCRIBE
                    </Button>
                </div>
            </form>

            <Affix offsetBottom={0}>
                <div className="formStepper">
                    <img src={car} alt="Car" className="formStepperCar step8" />
                    <img src={road} alt="Road" className="formStepperRoad" />
                </div>
            </Affix>
        </div>
    );
};

export default DeliveryInformationForm;
